<template>
    <div class="m-panel" style="position: relative;margin-left: 50px">
        <label v-if="showMapBack" class="mapBack" @click="mapBack">{{ $t('返回') }}</label>
        <Echart :options="option" style="height: 100%" ref="map" @mousemove="mousemove" @mouseout="mouseout" @click="clickMap"></Echart>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';
import { postAction,getAction } from '@/api/manage'
import configService from '@/utils/service/config.service'
var sxmap =  require("@/assets/mock/baoding.json");
var shangluo =  require("@/assets/mock/shangluo.json");
var wangdu =  require("@/assets/mock/wangduxian.json");
var hejing = require("@/assets/mock/hejing.json");
import { mapGetters } from 'vuex'

var timer = null
var index = -1;
var mapDate = [{
        name: '望都县',
        value: [115.15916,38.705135, 29999],
        status: 0
    },
    {
        name: '清苑区',
        value: [115.49951,38.77358, 29999],
        status: 1
    },
    {
        name: '顺平县',
        value: [115.122366,38.847354, 29999],
        status: 1
    },
    {
        name: '唐县',
        value: [114.982086,38.757375],
        status: 1
    },
    {
        name: '曲阳县',
        value: [114.704055,38.619992],
        status: 1
    },
    {
        name: '涿州市',
        value: [115.973409,39.485765],
        status: 1
    }
];
var shangluoCicles = [{
        name: '柞水县',
        value: [109.111249,33.682773, 29999],
        status: 0
    },
    {
        name: '洛南县',
        value: [110.145716,34.088502, 29999],
        status: 1
    },
    {
        name: '丹凤县',
        value: [110.33191,33.694711, 29999],
        status: 1
    },
    {
        name: '商南县',
        value: [110.885437,33.526367],
        status: 1
    },
    {
        name: '商南县',
        value: [110.653665,33.346962],
        status: 0
    },
    {
        name: '山阳县',
        value: [109.880435,33.530411],
        status: 1
    },
    {
        name: '山阳县',
        value: [109.990435,33.530411],
        status: 1
    },
    {
        name: '商州区',
        value: [109.937685,33.869208],
        status: 1
    },
    {
        name: '镇安县',
        value: [109.151075,33.423981],
        status: 1
    }
];
var mapDate2 = [{
        name: '望都县',
        value: [115.15916,38.705135, 29999],
        status: 1
    }];
export default {
    data() {
        return {
            option: {},
            showMapBack: false,
            url: {
                queryMeterAddrInfoByOrgCode: '/jeecg-charge/meter/meterUserinfo/queryMeterAddrInfoByOrgCode'
            },
            meterList: []
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.chooseCityMap()
            var that = this
            index = -1;
            /*
            setTimeout(() =>{
                timer = setInterval(function() {
                    // 隐藏提示框
                    that.$refs.map.dispatchAction({
                        type: 'hideTip',
                        seriesIndex: 0,
                        dataIndex: index
                    });
                    // 显示提示框
                    that.$refs.map.dispatchAction({
                        type: 'showTip',
                        seriesIndex: 0,
                        dataIndex: index + 1
                    });
                    // 取消高亮指定的数据图形
                    that.$refs.map.dispatchAction({
                        type: 'downplay',
                        seriesIndex: 0,
                        dataIndex: index
                    });
                    // 高亮指定的数据图形
                    that.$refs.map.dispatchAction({
                        type: 'highlight',
                        seriesIndex: 0,
                        dataIndex: index + 1
                    });
                    index++;
                    if (index > 13) {
                        index = -1;
                    }
                }, 2000);
            },1000)
            */
        })
    },
    methods: {
        ...mapGetters(["userInfo"]),
        queryMeterAddrInfoByOrgCode() {
            this.meterList = []
            // 查看单位所安装表的坐标信息
            getAction(this.url.queryMeterAddrInfoByOrgCode,{}).then((res)=> {
                if(res.success) {
                    for(let i = 0;i<res.result.length;i++) {
                        let data = res.result[i]
                        let value = [data.userMeterLng,data.userMeterLat]
                        this.meterList.push({name: data.userMeterAddr,meterId: data.meterId,userId: data.userId,userPhone: data.userPhone,userMeterAddr: data.userMeterAddr,value: value})
                    }
                    this.$nextTick(() => {
                        this.createMap(hejing,this.meterList)
                    })
                }
            })
        },
        chooseCityMap() {
            if(this.userInfo().orgCode === 'A29'){
                // 和静县
                //this.createMap(hejing,mapDate)
                //this.queryMeterAddrInfoByOrgCode()
                let hejinMapDate = [{
                    name: '清泉水利综合服务公司',
                    value: [86.387525,42.34664, 29999],
                    status: 1
                }]
                            this.createMap(hejing,hejinMapDate)
            }else if(configService.backType == 1) {
                // 如果是西安测试的则显示为商洛的地图
                this.createMap(shangluo,shangluoCicles)
            }else{
                this.createMap(sxmap,mapDate)
            }
        },
        mapBack() {
            // 地图子集返回至上一层
            this.chooseCityMap()
            this.showMapBack = false
        },
        createMap(mapname,mapDate) {
            /**
            此版本通过设置geoindex && seriesIndex: [1] 属性来实现geo和map共存，来达到hover散点和区域显示tooltip的效果

            默认情况下，map series 会自己生成内部专用的 geo 组件。但是也可以用这个 geoIndex 指定一个 geo 组件。这样的话，map 和 其他 series（例如散点图）就可以共享一个 geo 组件了。并且，geo 组件的颜色也可以被这个 map series 控制，从而用 visualMap 来更改。
            当设定了 geoIndex 后，series-map.map 属性，以及 series-map.itemStyle 等样式配置不再起作用，而是采用 geo 中的相应属性。

            http://echarts.baidu.com/option.html#series-map.geoIndex

            并且加了pin气泡图标以示数值大小
            */

            //this.$refs.map.showLoading();
            var mapInit = () => {
                let geoJson = mapname
                    echarts.registerMap('shanxi', geoJson);
                    this.$refs.map.hideLoading();
                    this.option = {
                        /*
                        backgroundColor: new echarts.graphic.RadialGradient(
                                    0.5, 0.5, 1,
                                [
                                    {offset: 0, color: 'rgba(4,25,96,0.8)'},
                                    {offset: 0.3, color: 'rgba(4,25,96,0.8)'},
                                    {offset: 0.5, color: 'rgba(0,6,62,1)'},
                                    {offset: 0.6, color: 'rgba(0,6,62,0)'},

                                ]
                            ),*/
                        title: {
                            show: false,
                            top: 20,
                            text: this.$t('地图展示'),
                            subtext: '',
                            x: 'center',
                            textStyle: {
                                color: '#ccc'
                            }
                        },
                        tooltip: {
                            trigger: 'item',
                            backgroundColor: 'rgba(0,0,0,0)',
                            formatter: function(item) {
                                
                                if (item.componentSubType === 'effectScatter'&&item.data.name === '清泉水利综合服务公司') {
                                console.log(item, 'item!!!!')
                                    let tipHtml2 = '';
                                    tipHtml2 = '<div style="background:rgba(0,2,89,0.8);border-radius:10px;padding:10px;box-shadow:0 0 10px #666">' +
                                        '<div style="color:#fff;height:20px;border-radius:6px;font-size:20px;line-height:20px;margin:0 2px;">' + item.data.name + '</div>' +
                                        /*
                                        '<div style="color:#fff;padding:4px 6px">' +
                                        '<span style="font-size:16px;">' + '位置：北纬39°36′29.76″ 东经109°46′52.78″ ' + '</span>' +
                                        '</div>' + 
                                        '<div style="color:#fff;padding:4px 6px">' +
                                        '<span style="font-size:16px;">' + '联系人：丁全 ' + '</span>' +
                                        '</div>' + 
                                        '<div style="color:#fff;padding:4px 6px">' +
                                        '<span style="font-size:16px;">' + '联系电话：18647758640 ' + '</span>' +
                                        '</div>' + 
                                        */
                                        '</div>';
                                    return tipHtml2;
                                }
                            }
                        },
                        geo: [
                            /*
                            {
                                map: 'shanxi',
                                aspectScale: 1, //长宽比
                                zoom: 1.1,
                                roam: false,
                                itemStyle: {
                                    normal: {
                                        shadowColor: '#019AF3',
                                        shadowBlur: 50,
                                        //shadowBlur: 15,
                                    }
                                }
                            },*/
                            {
                            map: 'shanxi',
                            aspectScale: 1, //长宽比
                            zoom: 1.1,
                            roam: false,
                            itemStyle: {
                                normal: {
                                    areaColor: '#03317F',
                                    shadowColor: '#0F3A93',
                                    shadowOffsetX: 10,
                                    shadowOffsetY: 10,
                                    //shadowBlur: 15,
                                },
                                emphasis: {
                                    areaColor: '#2AB8FF',
                                    borderWidth: 0,
                                    color: 'green',
                                    label: {
                                        show: false
                                    }
                                }
                            }
                        }],
                        series: [{
                                type: 'map',
                                aspectScale: 1, //长宽比
                                label: {
                                    normal: {
                                        show: true,
                                        textStyle: {
                                            color: '#fff'
                                        }
                                    },
                                    emphasis: {
                                        textStyle: {
                                            color: '#fff'
                                        }
                                    }
                                },

                                itemStyle: {
                                    normal: {
                                        borderColor: '#038EAC',
                                        shadowBlur: '#0F3A93',
                                        borderWidth: 1,
                                        areaColor: '#0A0A3A'
                                    },
                                    emphasis: {
                                        areaColor: '#03317F',// 高亮的背景色
                                        borderWidth: 2,
                                        borderColor: '#6CAEFB',
                                        shadowColor: '#6CAEFB',
                                        shadowBlur: 15,
                                        shadowOffsetX: 0,
                                        shadowOffsetY: 0
                                    }
                                },
                                zoom: 1.1,
                                roam: false,
                                map: 'shanxi' //使用
                                // data: this.difficultData //热力图数据   不同区域 不同的底色
                            },
                            {
                                type: 'effectScatter',
                                coordinateSystem: 'geo',
                                showEffectOn: 'render',
                                rippleEffect: {
                                    period: 4,
                                    scale: 4,
                                    brushType: 'stroke'
                                },
                                hoverAnimation: true,
                                itemStyle: {
                                    normal: {
                                        color:function(params){
                                            if(params.data.status == 0) {
                                                return 'red'
                                            }
                                            return '#1FB6C5';
                                        },
                                        shadowBlur: 10,
                                        shadowColor: '#333'
                                    }
                                },
                                data: mapDate
                            }

                        ]
                    };
            }
            setTimeout(function() {
                mapInit()
            }, 1000);
        },
        mousemove(e) {
            clearInterval(timer);
                    this.$refs.map.dispatchAction({
                        type: 'downplay',
                        seriesIndex: 0
                    });
                    this.$refs.map.dispatchAction({
                        type: 'highlight',
                        seriesIndex: 0,
                        dataIndex: e.dataIndex
                    });
                    this.$refs.map.dispatchAction({
                        type: 'showTip',
                        seriesIndex: 0,
                        dataIndex: e.dataIndex
                    });
        },
        mouseout(e) {
            this.maphighlight(e)
        },
        maphighlight(e) {
            clearInterval(timer);
            this.$refs.map.dispatchAction({
                type: 'downplay',
                seriesIndex: 0,
                dataIndex: e.dataIndex
            }); //鼠标移出后先把上次的高亮取消
            let that = this
            timer = setInterval(function() {
                // 隐藏提示框
                that.$refs.map.dispatchAction({
                    type: 'hideTip',
                    seriesIndex: 0,
                    dataIndex: index
                });
                // 显示提示框
                that.$refs.map.dispatchAction({
                    type: 'showTip',
                    seriesIndex: 0,
                    dataIndex: index + 1
                });
                // 取消高亮指定的数据图形
                that.$refs.map.dispatchAction({
                    type: 'downplay',
                    seriesIndex: 0,
                    dataIndex: index
                });
                // 高亮指定的数据图形
                that.$refs.map.dispatchAction({
                    type: 'highlight',
                    seriesIndex: 0,
                    dataIndex: index + 1
                });
                index++;
                if (index > 13) {
                    index = -1;
                }
            }, 2000);
        },
        clickMap(e) {
            var mapJson = [{
                    name: "望都县",
                    json: wangdu
                }
            ]
            var chooseName = mapJson.filter(item => {
                return item.name == e.name
            })
            if(chooseName.length>0) {
                let mapname = chooseName[0].json
                let mapDate = []
                this.createMap(mapname,mapDate2)
                this.showMapBack = true
            }
        }
    },
    beforeDestroy() {
        clearInterval(timer);
        timer = null;
    }
}
</script>
<style scoped>
.mapBack{
    background: #00C6DC;
    color: #fff;
    position: absolute;
    top: 10px;
    right: 40px;
    z-index: 999;
    box-shadow: 0 0 25px 0 #00C6DC;
    border-radius: 2px;
    border-radius: 2px;
    padding: 10px 20px;
    cursor: pointer;
}
</style>